/*
 *  Source IDs are optional free-text references to an external system. An empty
 *  (or whitespace-only) value is meaningless and must be stored as null rather
 *  than an empty string, which would otherwise collide across records.
 */
const normalizeSourceId = (sourceId?: string | null): string | null => {
  const trimmed = (sourceId || '').trim()
  return trimmed === '' ? null : trimmed
}

export { normalizeSourceId }
